import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

import { ProfileFieldPickerComponent } from '../profile-field-picker.component';

@Component({
  selector: 'plugins-profile-field-picker-dropdown',
  standalone: false,
  templateUrl: './profile-field-picker-dropdown.component.html',
  styleUrl: './profile-field-picker-dropdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileFieldPickerDropdownComponent extends ProfileFieldPickerComponent {
  readonly maxSelected = input<number>();

  readonly profileFieldsOptions = computed(() => {
    const profileFields = this.profileFields();
    if (!profileFields) {
      return [];
    }
    return profileFields.map(({ key }) => this.parseField(key));
  });

  readonly selectedOptionsFormat = (options: string[]) => {
    return options.map((option) => this.normalizeField(option)).join(', ');
  };
}
